/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BaseDimensionWidgetConfiguration extends models.BaseGroupByDataWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("BaseDimensionWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return BaseDimensionWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<BaseDimensionWidgetConfiguration>): BaseDimensionWidgetConfiguration {
        let obj = Object.assign(new BaseDimensionWidgetConfiguration(), model);
        BaseDimensionWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BaseDimensionWidgetConfiguration>): BaseDimensionWidgetConfiguration {
        if (!model) return null;
        return BaseDimensionWidgetConfiguration.newInstance(<BaseDimensionWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BaseDimensionWidgetConfiguration) {
        if (!obj) return;

        models.BaseDimensionWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BaseDimensionWidgetConfiguration): boolean {
        if (models.BaseGroupByDataWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BaseDimensionWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.dimensionDetails) {
            models.BillingGroupByDetails.fixupPrototype(this.dimensionDetails);
        }
        if (this.dimension_by_account_type) {
            models.ServiceAccountNativeDetailsBase.fixupPrototype(this.dimension_by_account_type);
        }
    }

    dimensionDetails: models.BillingGroupByDetails;

    /**
     * Account Type as Dimension to filter child accounts
     */
    dimension_by_account_type: models.ServiceAccountNativeDetailsBase;

    /**
     * Dimension is based on Resource Tag keys
     */
    dimension_tag_keys: boolean;

    /**
     * Dimension is based on Resource Tag status
     */
    dimension_tag_status: boolean;

    /**
     * Dimension is based on workload type
     */
    dimension_workload_type: boolean;

}
